// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Loading_Loading__tNCSj","Circle":"Loading_Circle__1PqIG","spin":"Loading_spin__2KgBV"};